export const SESSION_STORAGE_KEY = {
  USER_NAME: 'userName',
  USER_EMAIL: 'userEmail',
  USER_UPN: 'userUPN',
  USER_IMAfurGE: 'userImage',
  GRAPH_ACCESS_TOKEN: 'god-graphAccessToken',
  API_ACCESS_TOKEN: 'god-apiAccessToken',
};

export const REQUEST_STATUS = {
  DRAFT: {
    TEXT: 'Draft',
    VALUE: 2,
  },
  PENDING_VALIDTION: {
    TEXT: 'Pending Validation',
    VALUE: 3,
  },
  PENDING_PROPOSAL: {
    TEXT: 'Pending Proposal',
    VALUE: 4,
  },
  PENDING_REMOVAL: {
    TEXT: 'Pending Removal',
    VALUE: 5,
  },
  PENDING_REINSTATEMENT: {
    TEXT: 'Pending Reinstatement',
    VALUE: 7,
  },
  PENDING_PAINTING: {
    TEXT: 'Pending Painting',
    VALUE: 12,
  },
  PENDING_QAQC: {
    TEXT: 'Pending QAQC',
    VALUE: 8,
  },
  IN_SERVICE: {
    TEXT: 'In-service',
    VALUE: 6,
  },
  BILLING: {
    TEXT: 'Billing',
    VALUE: 9,
  },
  CLOSED: {
    TEXT: 'Closed',
    VALUE: 11,
  },
  CANCELLED: {
    TEXT: 'Cancelled',
    VALUE: 10,
  },
  REJECTED: {
    TEXT: 'Rejected',
    VALUE: 1,
  },
  PENDING_DISMANTLEMENT: {
    TEXT: 'Pending Dismantlement',
    VALUE: 13,
  },
  PENDING_INSPECTION: {
    TEXT: 'Pending Inspection',
    VALUE: 14,
  },
  PENDING_ERECTION: {
    TEXT: 'Pending Erection',
    VALUE: 15,
  },
  OUT_OF_SERVICE: {
    TEXT: 'Out of Service',
    VALUE: 16,
  },
};

export const TYPE_OF_REQUEST = {
  ALL: {
    TEXT: 'All',
    VALUE: 0,
  },
  INSULATION_REINSTATEMENT: {
    TEXT: 'Insulation Reinstatement',
    VALUE: 1,
  },
  INSULATION_REMOVAL_AND_REINSTATEMENT: {
    TEXT: 'Insulation Removal & Reinstatement',
    VALUE: 2,
  },
  PAINTING_REQUEST: {
    TEXT: 'Painting Request',
    VALUE: 3,
  },
  SCAFFOLDING_REQUEST: {
    TEXT: 'Scaffolding Request',
    VALUE: 4,
  },
};

export const TYPE_INSULATION_WORK = {
  INSULATION_REMOVAL_AND_REINSTATEMENT: {
    TEXT: 'Insulation Removal & Reinstatement',
    VALUE: 1,
  },
  METAL_CLADDING_FABRICTION_INSTALLATION: {
    TEXT: 'Metal cladding fabriction & installation',
    VALUE: 2,
  },
  INSULATION_REINSTATEMENT: {
    TEXT: 'Insulation Reinstatement',
    VALUE: 3,
  },
  PROTECTION_WIRE_CAGE_REMOVAL_REINSTATEMENT: {
    TEXT: 'Protection Wire Cage Removal & Reinstatement',
    VALUE: 4,
  },
  PROTECTION_WIRE_CAGE_REINSTATEMENT: {
    TEXT: 'Protection Wire Cage Reinstatement',
    VALUE: 5,
  },
};

export const AREA = {
  MLNG_SATU: {
    TEXT: 'MLNG SATU',
    VALUE: 1,
  },
  MLNG_DUA: {
    TEXT: 'MLNG DUA',
    VALUE: 2,
  },
  MLNG_TIGA: {
    TEXT: 'MLNG TIGA',
    VALUE: 3,
  },
  TRAIN_9: {
    TEXT: 'TRAIN 9',
    VALUE: 4,
  },
  UTILITIES: {
    TEXT: 'UTILITIES',
    VALUE: 5,
  },
  TERMINAL: {
    TEXT: 'TERMINAL',
    VALUE: 6,
  },
  NON_MANUFACTURING: {
    TEXT: 'NON-MANUFACTURING',
    VALUE: 7,
  },
  Area_1: {
    TEXT: 'Area 1',
    VALUE: 8,
  },
  Area_2: {
    TEXT: 'Area 2',
    VALUE: 9,
  },
};

export const SECTION = {
  AIN_1: { TEXT: 'AIN1', VALUE: 1 },
  AIN_2: { TEXT: 'AIN2', VALUE: 2 },
  AIN_3: { TEXT: 'AIN3', VALUE: 3 },
  AIN_MEC: { TEXT: 'AIN MEC', VALUE: 4 },
  AIN_ELE: { TEXT: 'AIN ELE', VALUE: 5 },
  AIN_INS: { TEXT: 'AIN INS', VALUE: 6 },
  AIN_CVL: { TEXT: 'AIN CVL', VALUE: 7 },
  AIN_WSH: { TEXT: 'AIN WSH', VALUE: 8 },
  AIN_ESM: { TEXT: 'AIN ESM', VALUE: 9 },
  AIN_CAP: { TEXT: 'AIN CAP', VALUE: 10 },
  AIN_RIM: { TEXT: 'AIN RIM', VALUE: 11 },
  TA_1: { TEXT: 'TA 1', VALUE: 12 },
  TA_2: { TEXT: 'TA 2', VALUE: 13 },
  OPS_1: { TEXT: 'OPS1', VALUE: 14 },
  OPS_2: { TEXT: 'OPS2', VALUE: 15 },
  OPS_3: { TEXT: 'OPS3', VALUE: 16 },
  OPS_4: { TEXT: 'OPS4', VALUE: 17 },
  OPS_5: { TEXT: 'OPS5', VALUE: 18 },
  OPS_6: { TEXT: 'OPS6', VALUE: 19 },
  TES_1: { TEXT: 'TES1', VALUE: 20 },
  TES_2: { TEXT: 'TES2', VALUE: 21 },
  TES_3: { TEXT: 'TES3', VALUE: 22 },
  TES_5: { TEXT: 'TES5', VALUE: 23 },
  TES_7: { TEXT: 'TES7', VALUE: 24 },
  FMA: { TEXT: 'FMA', VALUE: 25 },
  HSSE: { TEXT: 'HSSE', VALUE: 26 },
  PCD: { TEXT: 'PCD', VALUE: 27 },
  OTHERS: { TEXT: 'OTHERS', VALUE: 28 },
  Section1: { TEXT: 'Section1', VALUE: 29 },
  Section2: { TEXT: 'Section2', VALUE: 30 },
};

export const FORMAT_DATE = {
  UTC_TIME: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
  FULL_DATETIME: 'YYYY-MM-DDTHH:mm:ss.SSSS',
  SHORT_MONTH_DATE: 'DD-MMM-YYYY',
  FULL_DATETIME_HOUR: 'DD-MMM-YYYY HH:mm A',
};

export const STATISTIC = [
  {
    TYPE: 'numDraft',
    TITLE: 'Draft',
    STATUS: REQUEST_STATUS.DRAFT.VALUE,
    COLOR_STOP1: '#677C91',
    COLOR_STOP2: '#D3DEE8',
    VALUE: 2,
  },
  {
    TYPE: 'numInService',
    TITLE: 'In-service ',
    STATUS: REQUEST_STATUS.IN_SERVICE.VALUE,
    COLOR_STOP1: '#0E7E30',
    COLOR_STOP2: '#E5F4E7',
    VALUE: 6,
  },
  {
    TYPE: 'numPendingProposal',
    TITLE: 'Pending Proposal',
    STATUS: REQUEST_STATUS.PENDING_PROPOSAL.VALUE,
    COLOR_STOP1: '#F3A438',
    COLOR_STOP2: '#FDF7E0',
    VALUE: 4,
  },
  {
    TYPE: 'numPendingValidation',
    TITLE: 'Pending Validation',
    STATUS: REQUEST_STATUS.PENDING_VALIDTION.VALUE,
    COLOR_STOP1: '#009089',
    COLOR_STOP2: '#DFF1F1',
    VALUE: 3,
  },
  {
    TYPE: 'numPendingRemoval',
    TITLE: 'Pending Removal',
    STATUS: REQUEST_STATUS.PENDING_REMOVAL.VALUE,
    COLOR_STOP1: '#639DD6',
    COLOR_STOP2: '#E2F1FC',
    VALUE: 5,
  },
  {
    TYPE: 'numPendingQaQc',
    TITLE: 'Pending QAQC',
    STATUS: REQUEST_STATUS.PENDING_QAQC.VALUE,
    COLOR_STOP1: '#4B66AD',
    COLOR_STOP2: '#FFFFFF',
    VALUE: 8,
  },
  {
    TYPE: 'numBilling',
    TITLE: 'Billing',
    STATUS: REQUEST_STATUS.BILLING.VALUE,
    COLOR_STOP1: '#ED7E80',
    COLOR_STOP2: '#FFEBEE',
    VALUE: 9,
  },
  {
    TYPE: 'numPendingReinstatement',
    TITLE: 'Pending Reinstatement',
    STATUS: REQUEST_STATUS.PENDING_REINSTATEMENT.VALUE,
    COLOR_STOP1: '#64519B',
    COLOR_STOP2: '#EFE8F3',
    VALUE: 7,
  },
  {
    TYPE: 'numPendingPainting',
    TITLE: 'Pending Painting',
    STATUS: REQUEST_STATUS.PENDING_PAINTING.VALUE,
    COLOR_STOP1: '#463728',
    COLOR_STOP2: 'rgba(253, 254, 213, 0.71)',
    VALUE: 12,
  },
];

export const STATUS_COLOR_TABLE = [
  {
    TYPE: 1,
    STATUS_LABEL: 'Rejected',
    COLOR: '#FFFFFF',
    BACKGROUND_COLOR: '#EB6F70',
  },
  {
    TYPE: 2,
    STATUS_LABEL: 'Draft',
    COLOR: '#677C91',
    BACKGROUND_COLOR: '#D3DEE8',
  },
  {
    TYPE: 3,
    STATUS_LABEL: 'Pending Validation',
    COLOR: '#009089',
    BACKGROUND_COLOR: '#DFF1F1',
  },
  {
    TYPE: 4,
    STATUS_LABEL: 'Pending Proposal',
    COLOR: '#F08800',
    BACKGROUND_COLOR: '#FDF7E0',
  },
  {
    TYPE: 5,
    STATUS_LABEL: 'Pending Removal',
    COLOR: '#005DB9',
    BACKGROUND_COLOR: '#E2F1FC',
  },
  {
    TYPE: 6,
    STATUS_LABEL: 'In-service',
    COLOR: '#007724',
    BACKGROUND_COLOR: '#E5F4E7',
  },
  {
    TYPE: 7,
    STATUS_LABEL: 'Pending Reinstatement',
    COLOR: '#633185',
    BACKGROUND_COLOR: '#EFE8F3',
  },
  {
    TYPE: 8,
    STATUS_LABEL: 'Pending QAQC',
    COLOR: '#415EA9',
    BACKGROUND_COLOR: '#E4E8F3',
  },
  {
    TYPE: 9,
    STATUS_LABEL: 'Billing',
    COLOR: '#FB392E',
    BACKGROUND_COLOR: '#FFEBEE',
  },
  {
    TYPE: 10,
    STATUS_LABEL: 'Cancelled',
    COLOR: '#FFFFFF',
    BACKGROUND_COLOR: '#9FB0C2',
  },
  {
    TYPE: 11,
    STATUS_LABEL: 'Closed',
    COLOR: '#FFFFFF',
    BACKGROUND_COLOR: '#9FB0C2',
  },
  {
    TYPE: 12,
    STATUS_LABEL: 'Pending Painting',
    COLOR: '#463728',
    BACKGROUND_COLOR: '#FDFED5B5',
  },
  {
    TYPE: 13,
    STATUS_LABEL: 'Pending Dismantlement',
    COLOR: '#463728',
    BACKGROUND_COLOR: '#FDFED5B5',
  },
  {
    TYPE: 14,
    STATUS_LABEL: 'Pending Inspection',
    COLOR: '#463728',
    BACKGROUND_COLOR: '#FDFED5B5',
  },
  {
    TYPE: 15,
    STATUS_LABEL: 'Pending Erection',
    COLOR: '#463728',
    BACKGROUND_COLOR: '#FDFED5B5',
  },
  {
    TYPE: 16,
    STATUS_LABEL: 'Out of Service',
    COLOR: '#463728',
    BACKGROUND_COLOR: '#FDFED5B5',
  },
];

export const MESSAGE_NOTICE = {
  SUCCESS: 'success-message',
  ERROR: 'error-message',
};

export const STATUS_FILTER_COLUMN = {
  DRAFT: {
    TEXT: 'Draft',
    VALUE: 2,
  },
  PENDING_VALIDTION: {
    TEXT: 'Pending Validation',
    VALUE: 3,
  },
  PENDING_PROPOSAL: {
    TEXT: 'Pending Proposal',
    VALUE: 4,
  },
  PENDING_REMOVAL: {
    TEXT: 'Pending Removal',
    VALUE: 5,
  },
  PENDING_REINSTATEMENT: {
    TEXT: 'Pending Reinstatement',
    VALUE: 7,
  },
  PENDING_PAINTING: {
    TEXT: 'Pending Painting',
    VALUE: 12,
  },
  PENDING_QAQC: {
    TEXT: 'Pending QAQC',
    VALUE: 8,
  },
  IN_SERVICE: {
    TEXT: 'In-service',
    VALUE: 6,
  },
  BILLING: {
    TEXT: 'Billing',
    VALUE: 9,
  },
  PENDING_DISMANTLEMENT: {
    TEXT: 'Pending Dismantlement',
    VALUE: 13,
  },
  PENDING_INSPECTION: {
    TEXT: 'Pending Inspection',
    VALUE: 14,
  },
  PENDING_ERECTION: {
    TEXT: 'Pending Erection',
    VALUE: 15,
  },
  OUT_OF_SERVICE: {
    TEXT: 'Out of Service',
    VALUE: 16,
  },
};

export const STATUS_FILTER_INSULATION = {
  PENDING_VALIDTION: {
    TEXT: 'Pending Validation',
    VALUE: 3,
  },
  PENDING_REMOVAL: {
    TEXT: 'Pending Removal',
    VALUE: 5,
  },
  PENDING_QAQC: {
    TEXT: 'Pending QAQC',
    VALUE: 8,
  },
  BILLING: {
    TEXT: 'Billing',
    VALUE: 9,
  },
};

export const STATUS_FILTER_REQUESTOR = {
  DRAFT: {
    TEXT: 'Draft',
    VALUE: 2,
  },
  IN_SERVICE: {
    TEXT: 'In-service',
    VALUE: 6,
  },
};

export const STATUS_FILTER_CONTRACTOR = {
  PENDING_PROPOSAL: {
    TEXT: 'Pending Proposal',
    VALUE: 4,
  },
  PENDING_REMOVAL: {
    TEXT: 'Pending Removal',
    VALUE: 5,
  },
  PENDING_REINSTATEMENT: {
    TEXT: 'Pending Reinstatement',
    VALUE: 7,
  },
  PENDING_PAINTING: {
    TEXT: 'Pending Painting',
    VALUE: 12,
  },
};

export const STATUS_FILTER_PAINTING = {
  PENDING_VALIDTION: {
    TEXT: 'Pending Validation',
    VALUE: 3,
  },
  PENDING_QAQC: {
    TEXT: 'Pending QAQC',
    VALUE: 8,
  },
  BILLING: {
    TEXT: 'Billing',
    VALUE: 9,
  },
};

export const SURFACE_PREP = [
  {
    TEXT: 'SA 1',
    VALUE: 1,
  },
  {
    TEXT: 'SA 2',
    VALUE: 2,
  },
  {
    TEXT: 'SA 2.5',
    VALUE: 3,
  },
  {
    TEXT: 'ST 3',
    VALUE: 4,
  },
  {
    TEXT: 'Others',
    VALUE: 5,
  },
];

export const ROLE_USER_MANAGEMENT = [
  {
    TEXT: 'Administrator',
    VALUE: 1,
  },
  {
    TEXT: 'Requestor',
    VALUE: 2,
  },
  {
    TEXT: 'Insulation Team',
    VALUE: 3,
  },
  {
    TEXT: 'Painting Team',
    VALUE: 5,
  },
  {
    TEXT: 'Contractor',
    VALUE: 4,
  },
];

export const APPLICABLE_SERVICE = [
  {
    TEXT: 'Insulation',
    VALUE: 1,
  },
  {
    TEXT: 'Painting',
    VALUE: 2,
  },
];
